import { Injectable, signal } from "@angular/core";
import { CartPromoOverrides } from "../myqq.models";

@Injectable({
  providedIn: "root", // Makes the service a singleton and available throughout the application
})
export class CartService {
  private _cartPromoOverridesSignal = signal<CartPromoOverrides>({});
  updateCartPromoOverrides(newValue: CartPromoOverrides): void {
    this._cartPromoOverridesSignal.set(newValue);
  }
  public cartPromoOverrides = this._cartPromoOverridesSignal.asReadonly();
}
